import styled from '@emotion/styled';

export const ParticipantsList = styled.div`
  background-color: white;

  padding: 20px 18px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
